import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { composeResolvers } from "@graphql-tools/resolvers-composition";
import { errorMessages, PURCHASABLE_BUFFER } from "@/lib/constants";
import { PURCHASE_ESTIMATE_ERROR_MESSAGES, VOUCHER_CODE_CHECK_ERROR_REASONS } from "@/lib/errors";
import { gql } from "@apollo/client";
import { isAuthenticated, ownerOnly, logicaErrorBody, isDateRangeIn } from "./helper";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type ProductOrder @cacheControl(scope: PRIVATE) {\n    product_order_id: Int\n    order: Order\n    product_id: Int\n    status: String\n    name: String\n    created_at: String\n    error: String\n  }\n\n  type Order {\n    order_id: Int\n    payment_method_id: Int\n    payment_amount: Int\n  }\n\n  type PurchaseEstimate {\n    product: Product\n    error: String\n  }\n\n  type Query {\n    purchaseEstimate(\n      productId: Int\n      paymentMethodId: Int\n      voucherCode: String\n      userVoucherId: Int\n    ): PurchaseEstimate\n  }\n\n  type Mutation {\n    purchaseExecute(\n      productId: Int\n      paymentInstrumentId: Int\n      voucherCode: String\n      userVoucherId: Int\n    ): ProductOrder\n  }\n"])));
export var resolvers = composeResolvers({
  Query: {
    purchaseEstimate: function () {
      var _purchaseEstimate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var productId, paymentMethodId, voucherCode, userVoucherId, dataSources, _res$voucher_code2, _checkResult$voucher_, _checkResult$voucher_2, checkResult, res, _res$voucher_code, userVoucher, couponVoucher, discount, price, _body$error, _body$error2, body, errorCode, reason, _ref3, code, message;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                productId = _ref.productId, paymentMethodId = _ref.paymentMethodId, voucherCode = _ref.voucherCode, userVoucherId = _ref.userVoucherId;
                dataSources = _ref2.dataSources;
                _context.prev = 2;

                if (!voucherCode) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return dataSources.voucherCode.check(voucherCode, {
                  productId: productId,
                  paymentMethodId: paymentMethodId
                });

              case 6:
                checkResult = _context.sent;

                if (checkResult !== null && checkResult !== void 0 && (_checkResult$voucher_ = checkResult.voucher_code) !== null && _checkResult$voucher_ !== void 0 && (_checkResult$voucher_2 = _checkResult$voucher_.voucher) !== null && _checkResult$voucher_2 !== void 0 && _checkResult$voucher_2.discount_price) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", {
                  error: "".concat(PURCHASE_ESTIMATE_ERROR_MESSAGES[22002], " \u30A8\u30E9\u30FC\u30B3\u30FC\u30C9: 22002")
                });

              case 9:
                _context.next = 11;
                return dataSources.purchase.estimate({
                  productId: productId,
                  paymentMethodId: paymentMethodId,
                  voucherCode: voucherCode
                });

              case 11:
                res = _context.sent;

                if (!(voucherCode && userVoucherId)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 15;
                return dataSources.user.voucher(userVoucherId);

              case 15:
                userVoucher = _context.sent;
                couponVoucher = res === null || res === void 0 ? void 0 : (_res$voucher_code = res.voucher_code) === null || _res$voucher_code === void 0 ? void 0 : _res$voucher_code.voucher; // バウチャーコードの割引と放送契約割引の割引価格を比較して放送契約割引の方が安かった場合はエラーにする

                if (!((userVoucher === null || userVoucher === void 0 ? void 0 : userVoucher.discount_price) >= (couponVoucher === null || couponVoucher === void 0 ? void 0 : couponVoucher.discount_price))) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return", {
                  error: errorMessages["purchaseEstimateInapplicable"]
                });

              case 19:
                if (!(res !== null && res !== void 0 && (_res$voucher_code2 = res.voucher_code) !== null && _res$voucher_code2 !== void 0 && _res$voucher_code2.voucher)) {
                  _context.next = 24;
                  break;
                }

                discount = res.voucher_code.voucher.discount_price;
                price = res.active_pricing.price;

                if (!(price <= discount)) {
                  _context.next = 24;
                  break;
                }

                return _context.abrupt("return", {
                  error: errorMessages["purchaseEstimateDiscountToLarge"]
                });

              case 24:
                return _context.abrupt("return", {
                  product: res
                });

              case 27:
                _context.prev = 27;
                _context.t0 = _context["catch"](2);
                console.log("purchaseEstimate error", _context.t0);
                body = logicaErrorBody(_context.t0);
                errorCode = body === null || body === void 0 ? void 0 : (_body$error = body.error) === null || _body$error === void 0 ? void 0 : _body$error.code;
                reason = body === null || body === void 0 ? void 0 : (_body$error2 = body.error) === null || _body$error2 === void 0 ? void 0 : _body$error2.reason_type;
                _ref3 = function () {
                  var _body$error3;

                  // バウチャーコードチェックAPIのバグで本来22001が返るところがnullになる
                  if ((!errorCode || errorCode === 22001) && reason) {
                    return VOUCHER_CODE_CHECK_ERROR_REASONS[reason];
                  }

                  return {
                    code: errorCode,
                    message: PURCHASE_ESTIMATE_ERROR_MESSAGES[errorCode] || (body === null || body === void 0 ? void 0 : (_body$error3 = body.error) === null || _body$error3 === void 0 ? void 0 : _body$error3.message) || errorMessages["subscriptionEstimate"]
                  };
                }(), code = _ref3.code, message = _ref3.message;
                return _context.abrupt("return", {
                  error: "".concat(message, " \u30A8\u30E9\u30FC\u30B3\u30FC\u30C9: ").concat(code)
                });

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 27]]);
      }));

      function purchaseEstimate(_x, _x2, _x3) {
        return _purchaseEstimate.apply(this, arguments);
      }

      return purchaseEstimate;
    }()
  },
  Mutation: {
    purchaseExecute: function () {
      var _purchaseExecute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _ref4, _ref5) {
        var productId, paymentInstrumentId, voucherCode, userVoucherId, req, dataSources, _req$userToken, product, purchaseAllowed, res, userId, _body$error4, _body$error5, body, errorCode, errMeesage;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                productId = _ref4.productId, paymentInstrumentId = _ref4.paymentInstrumentId, voucherCode = _ref4.voucherCode, userVoucherId = _ref4.userVoucherId;
                req = _ref5.req, dataSources = _ref5.dataSources;
                _context2.prev = 2;
                _context2.next = 5;
                return dataSources.product.productById({
                  id: productId
                });

              case 5:
                product = _context2.sent;
                purchaseAllowed = isDateRangeIn(product === null || product === void 0 ? void 0 : product.sales_start_at, product === null || product === void 0 ? void 0 : product.sales_end_at, {
                  buffer: PURCHASABLE_BUFFER,
                  default: true
                });

                if (purchaseAllowed) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", {
                  error: "販売期間外のため購入できません。"
                });

              case 9:
                _context2.next = 11;
                return dataSources.purchase.purchaseExecute({
                  productId: productId,
                  paymentInstrumentId: paymentInstrumentId,
                  voucherCode: voucherCode,
                  userVoucherId: userVoucherId
                });

              case 11:
                res = _context2.sent;
                // TODO：決済ID、ユーザーIDをログ出力する
                userId = req === null || req === void 0 ? void 0 : (_req$userToken = req.userToken) === null || _req$userToken === void 0 ? void 0 : _req$userToken.id;
                console.log("########## PurchaseExecute, userId: ".concat(userId, ", productId: ").concat(productId, " ##########"));
                console.log("purchaseExecute", res);
                console.log("########## PurchaseExecute End ##########");
                return _context2.abrupt("return", res.product_order);

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](2);
                console.log("purchaseExecute error", _context2.t0);
                body = logicaErrorBody(_context2.t0);
                errorCode = (body === null || body === void 0 ? void 0 : (_body$error4 = body.error) === null || _body$error4 === void 0 ? void 0 : _body$error4.code) || 500;
                errMeesage = (body === null || body === void 0 ? void 0 : (_body$error5 = body.error) === null || _body$error5 === void 0 ? void 0 : _body$error5.message) || errorMessages["purchaseExecute"];
                return _context2.abrupt("return", {
                  error: "".concat(errMeesage, " \u30A8\u30E9\u30FC\u30B3\u30FC\u30C9: ").concat(errorCode)
                });

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 19]]);
      }));

      function purchaseExecute(_x4, _x5, _x6) {
        return _purchaseExecute.apply(this, arguments);
      }

      return purchaseExecute;
    }()
  }
}, {
  "Mutation.purchaseExecute": [isAuthenticated(), ownerOnly()]
});